module.exports = __webpack_public_path__ + "img/alicebluelogo.d362074e.png";